import React, { FunctionComponent, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useAppSelector } from '../../../../App/Hooks/reduxHooks'
import { IActivity } from '../../../../App/store/features/activity/interface/IActivityList'
import { stringToHsl } from '../../../../App/Util/stringToHsl'
import {
  FormBackButton,
  FormBackButtonIcon,
  FormBackButtonText,
  FormHeader,
  FormListItem,
  FormListItemGraphic,
  FormListItemImage,
  FormListItemText,
  FormListNoActivity,
  FormUnOrderedList,
} from '../../FormSwitch/styles'
import { activityToAddedActivity } from '../utils/activityToAppointmentActivity'

import { ISharedProps } from './IProps'

interface IProps extends ISharedProps {
  isActivityViewOpen: boolean
  setActivityView: (toggleView: undefined | 'activity') => void
}

export const ActivityView: FunctionComponent<IProps> = ({
  setActivityView,
  isActivityViewOpen,
  setSelectedActivityArray,
  selectedActivityArray,
  defaultPersonUuids,
  activityList,
  personList,
}) => {
  const { t } = useTranslation()
  const [chosenActivityCategory, setChosenActivityCategory] = useState<
    IActivity[]
  >([])
  const [isActivityCategoryWindowOpen, setIsActivityCategoryWindowOpen] =
    useState<boolean>(false)
  const [filteredSearchResults] = useState<IActivity[] | undefined>(undefined)

  const { activityCategories } = useAppSelector(state => ({
    activityCategories: state.activity.categories,
  }))

  if (!isActivityViewOpen || !activityCategories) {
    return null
  }

  const onActivityClicked = (activityId: number) => {
    setChosenActivityCategory(
      activityList.filter(obj => obj.categoryId === activityId),
    )
  }
  const updateSelectedActivities = (activity: IActivity) => {
    setSelectedActivityArray({
      data: [
        ...selectedActivityArray,
        activityToAddedActivity(
          activity,
          activityList,
          defaultPersonUuids,
          personList,
        ),
      ],
      actionType: 'add',
    })
  }

  const menuBackButtonClicked = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    setActivityView('activity')
    setIsActivityCategoryWindowOpen(false)
    setChosenActivityCategory([])
    if (chosenActivityCategory.length === 0) {
      setActivityView(undefined)
    }
  }

  return (
    <>
      <FormHeader>{t('Add activity')}</FormHeader>
      <FormBackButton onClick={e => menuBackButtonClicked(e)}>
        <FormBackButtonIcon icon="chevron-left" />
        <FormBackButtonText>{t('Back')}</FormBackButtonText>
      </FormBackButton>

      <FormUnOrderedList>
        {!filteredSearchResults && !isActivityCategoryWindowOpen
          ? activityCategories.map(category => (
              <FormListItem
                key={category.id}
                onClick={() => {
                  onActivityClicked(category.id)
                  setIsActivityCategoryWindowOpen(true)
                }}
              >
                {category.image !== null ? (
                  <FormListItemImage
                    src={`${category.image}&w=60&h=60&fit=crop`}
                    alt="activity-category-image"
                  />
                ) : (
                  <FormListItemGraphic
                    color={stringToHsl(category.name, 50, 50)}
                  />
                )}
                <FormListItemText>{category.name}</FormListItemText>
              </FormListItem>
            ))
          : chosenActivityCategory &&
            !filteredSearchResults &&
            chosenActivityCategory.map(activity => (
              <FormListItem
                key={activity.id}
                onClick={() => {
                  updateSelectedActivities(activity)
                  onActivityClicked(activity.id)
                  setActivityView(undefined)
                }}
              >
                {activity.image !== null ? (
                  <FormListItemImage
                    src={`${activity.image}&w=60&h=60&fit=crop`}
                    alt="activity-category-image"
                  />
                ) : (
                  <FormListItemGraphic color={activity.color} />
                )}
                <FormListItemText>{activity.name}</FormListItemText>
              </FormListItem>
            ))}
        {filteredSearchResults &&
          filteredSearchResults.map(filteredActivity => (
            <FormListItem
              key={filteredActivity.id}
              onClick={() => {
                updateSelectedActivities(filteredActivity)
                onActivityClicked(filteredActivity.id)
                setActivityView(undefined)
              }}
            >
              {filteredActivity.image !== null ? (
                <FormListItemImage
                  src={`${filteredActivity.image}&w=60&h=60&fit=crop`}
                  alt="activity-category-image"
                />
              ) : (
                <FormListItemGraphic color={filteredActivity.color} />
              )}

              <FormListItemText>
                {
                  // @ts-ignore
                  activityCategories.find(
                    oneCategory =>
                      oneCategory.id === filteredActivity.categoryId,
                  ).name
                }
                {filteredActivity.name}
              </FormListItemText>
            </FormListItem>
          ))}
      </FormUnOrderedList>
      {!filteredSearchResults &&
        isActivityCategoryWindowOpen &&
        chosenActivityCategory.length === 0 && (
          <FormListNoActivity>{t('No activities')}</FormListNoActivity>
        )}
    </>
  )
}
